
if (!customElements.get("shop-the-look-drawer")) {
  class ShopTheLookDrawer extends HTMLElement {
    constructor() {
      super();
      this.close = this.close.bind(this);
      this.open = this.open.bind(this);
      this._handleSectionLoad = this._handleSectionLoad.bind(this);
    }

    connectedCallback() {
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this._handleSectionLoad);
      }
      this.init();
    }

    disconnectedCallback() {
      if (Shopify.designMode) {
        window.removeEventListener("shopify:section:load", this._handleSectionLoad);
      }
      this._teardownListeners();
    }

    _handleSectionLoad() {
      this.init();
    }

    _teardownListeners() {
      if (this._abortController) {
        this._abortController.abort();
        this._abortController = null;
      }
    }

    init() {
      this._teardownListeners();
      this._abortController = new AbortController();
      const signal = this._abortController.signal;

      this.toggleState = false;
      if (!this.classList.contains("is--open")) {
        document.body?.classList.remove("overflow-hidden");
      }

      const closeBtn = this.querySelector(".button--close");
      const backdrop = this.querySelector(".shop-the-look-drawer__backdrop");

      if (closeBtn) {
        closeBtn.addEventListener("click", this.close, { signal });
      }
      if (backdrop) {
        backdrop.addEventListener("click", this.close, { signal });
      }

      document.querySelectorAll(".shop-the-look-drawer__trigger").forEach((element) => {
        element.addEventListener("click", this.open, { signal });
      });
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.body?.classList.add("overflow-hidden");
      this.classList.add("is--open");
    }

    close() {
      this.toggleState = false;
      document.body?.classList.remove("overflow-hidden");
      this.classList.remove("is--open");
      this.toggleAriaExpanded();
    }

    toggleAriaExpanded(event) {
      if (event) {
        const btn = event.target.closest("button");
        if (btn) btn.setAttribute("aria-expanded", true);
        this.querySelector(".button--close")?.setAttribute("aria-expanded", true);
      } else {
        document
          .querySelectorAll('[aria-controls="shop-the-look-drawer"]')
          .forEach((button) => {
            button.setAttribute("aria-expanded", false);
          });
      }
    }

  }

  customElements.define("shop-the-look-drawer", ShopTheLookDrawer);
}
